import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";

export default function SiteIntro() {
  const totalViews = videos.reduce((sum, video) => sum + video.views, 0);

  const stats = [
    { label: "视频条目", value: `${videos.length}+` },
    { label: "视频分类", value: `${categories.length}` },
    { label: "累计浏览", value: `${Math.round(totalViews / 10000)}万` },
  ];

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="flex flex-col justify-center p-6 md:p-10">
          <span className="inline-flex w-fit items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-information-line"></i>
            关于本站
          </span>
          <h2 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            高清视频内容聚合与资源导航
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            黄瓜视频下载专注于高清视频内容的聚合与分类导航，将电影、电视剧、综艺、动漫、纪录片、体育、音乐、游戏等类型的视频条目集中整理，方便用户按分类、地区、年份与清晰度快速筛选，并通过详情页了解每个条目的基本信息与资源流向。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            本站所有视频条目均为演示内容，仅用于展示内容聚合与资源导航的结构与交互，不提供真实播放或下载服务，相关资源导航按钮仅为外部跳转指示。
          </p>
          <div className="mt-6 grid grid-cols-3 gap-4">
            {stats.map((item) => (
              <div key={item.label} className="rounded-lg bg-background-100 p-3 text-center">
                <p className="font-heading text-xl font-bold text-primary-600">{item.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{item.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/search"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              浏览全部视频
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              了解我们
            </Link>
          </div>
        </div>
        <div className="relative h-64 w-full lg:h-auto">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20minimal%20streaming%20content%20library%20concept%20with%20stacked%20video%20thumbnails%20and%20soft%20teal%20green%20gradient%20background%2C%20clean%20geometric%20composition%2C%20high%20detail%2C%20muted%20consistent%20color%20palette%2C%20editorial%20abstract%20illustration&width=1000&height=900&seq=hg-intro-01&orientation=squarish"
            alt="黄瓜视频下载 - 高清视频内容聚合"
            title="黄瓜视频下载 高清视频内容聚合与资源导航"
            className="h-full w-full object-cover object-top"
          />
        </div>
      </div>
    </div>
  );
}